import {
  Box,
  Button,
  Card,
  CardContent,
  TextField,
  Typography,
} from "@mui/material";
import { cloneDeep } from "lodash";
import { useState } from "react";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { useNavigate } from "react-router-dom";
import { login } from "../services/auth";

function Login() {
  const [form, setForm] = useState({});
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  function handleOnChange(evt) {
    const newState = cloneDeep(form);
    newState[evt.target.name] = evt.target.value;
    setForm(newState);
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    try {
      const response = await login(form.email, form.password);
      if (response.user) {
        navigate("/cms");
      } else {
        setError("Credenziali non valide");
      }
    } catch (error) {
      setError(error.message);
    }
  };

  return (
    <div
      className="login-container"
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        backgroundColor: "#f4f6f8",
      }}
    >
      <Card
        className="login-card"
        sx={{
          padding: 4,
          boxShadow: 3,
          borderRadius: 2,
          maxWidth: 480,
          width: "100%",
        }}
      >
        <CardContent>
          <Button
            variant="contained"
            color="primary"
            startIcon={<ArrowBackIosIcon />}
            size="medium"
            sx={{
              mb: 2,
              backgroundColor: "#1976d2",
              "&:hover": { backgroundColor: "#1565c0" },
            }}
            onClick={() => navigate("/")}
          >
            Indietro
          </Button>
          <Box
            component="form"
            onSubmit={handleSubmit}
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 2,
              maxWidth: 400,
              margin: "0 auto",
              mt: 2,
            }}
          >
            <Typography
              variant="h4"
              component="div"
              sx={{ mb: 2, color: "#333", textAlign: "center" }}
            >
              Login
            </Typography>
            {error && (
              <div style={{ color: "red", textAlign: "center" }}>{error}</div>
            )}
            <TextField
              type="email"
              label="Email"
              name="email"
              value={form.email}
              onChange={handleOnChange}
              fullWidth
              required
            />
            <TextField
              label="Password"
              name="password"
              type="password"
              value={form.password}
              onChange={handleOnChange}
              fullWidth
              required
            />
            <Button
              type="submit"
              variant="contained"
              color="primary"
              fullWidth
              sx={{ mb: 2 }}
            >
              Invia
            </Button>
          </Box>
        </CardContent>
      </Card>
    </div>
  );
}

export default Login;
